import { Define } from '../../../core/decorators';
import { TAG_SECONDARY } from '../../../core/utils/constants/tags';
import { ButtonVariation } from '../button';
import { HTMLBnumButton } from '../button/bnum-button';
import { Variation } from '../button/bnum-button.internal/decorators';

/**
 * Bouton Bnum de type "Secondary".
 *
 * @category Buttons
 *
 * @structure Cas standard
 * <bnum-secondary-button>Texte du bouton</bnum-secondary-button>
 *
 * @structure Bouton avec icône
 * <bnum-secondary-button data-icon="home">Texte du bouton</bnum-secondary-button>
 *
 * @structure Bouton avec une icône à gauche
 * <bnum-secondary-button data-icon="home" data-icon-pos="left">Texte du bouton</bnum-secondary-button>
 *
 * @structure Bouton en état de chargement
 * <bnum-secondary-button loading>Texte du bouton</bnum-secondary-button>
 *
 * @structure Bouton arrondi
 * <bnum-secondary-button rounded>Texte du bouton</bnum-secondary-button>
 *
 * @structure Bouton cachant le texte sur les petits layouts
 * <bnum-secondary-button data-hide="small" data-icon="menu">Menu</bnum-secondary-button>
 */
@Define({ tag: TAG_SECONDARY })
@Variation(ButtonVariation.SECONDARY)
export class HTMLBnumSecondaryButton extends HTMLBnumButton {
	constructor() {
		super();
	}
}
